module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza20219.c7d5e3af.jpg";